import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { VerifyEmailPage } from '~/features/auth/pages/verify-email-page';

const searchSchema = z.object({
  user_id: z.string().optional(),
  token: z.string().optional(),
});

export const Route = createFileRoute('/verify-email')({
  validateSearch: searchSchema,
  component: VerifyEmailPage,
});
